import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'

import Header from "./Header";
import { GET, httpOk } from 'helpers/api'

function Layout() {
	const dispatch = useDispatch()
	const reduxAccount = useSelector(state => state.account)

	/* Ruxsatlarni ilova ochilganda qayta olamiz — egasining maketidagi bilan
	   BIR XIL (owner/Layout.js:18).

	   NEGA KERAK: kassirning bo'limlari galochka bilan boshqariladi
	   (`users_permissions`). Egasi galochka qo'ysa, ruxsat faqat LOGIN
	   javobida uzatilardi — ya'ni kassir chiqib-kirmaguncha yangi bo'lim
	   menyuda umuman ko'rinmasdi. Endi sahifani yangilash (F5) yetadi.

	   ⚠️ Bu kassirga yangi HUQUQ bermaydi — backend har so'rovda
	      `users_permissions` ni qaytadan tekshiradi (Helper::hasPermission). */
	useEffect(() => {
		async function refreshPermissions() {
			const response = await GET('/helper/my-permissions', {}, { loader: false })
			if (httpOk(response) && Array.isArray(response.data)) {
				dispatch({ type: 'CHANGE_ACCOUNT', payload: { ...reduxAccount, permissions: response.data } })
			}
		}
		refreshPermissions()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div id="layout-wrapper">
			<Header />
			<div>
				<div className="page-content">
					<Outlet />
				</div>
			</div>
		</div>
	)
}

export default Layout
